import GoldUpgradeCollection from "../../model/upgrade/gold/GoldUpgradeCollection";
import HeaderView from "../common/HeaderView";
import Page from "../framework/Page";
import ParentView from "../framework/ParentView";
import GoldUpgradeCollectionView from "./classic/GoldUpgradeCollectionView";

export default class GoldUpgradePanel extends ParentView {
    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {GoldUpgradeCollection} goldUpgradeCollection
     */
    constructor(parentId, elementId, goldUpgradeCollection) {
        super(parentId, elementId);

        this.addView(new HeaderView(this.elementId, this.elementId + '_header', 'Gold Upgrades'));

        this.addView(new GoldUpgradeCollectionView(this.elementId, this.elementId + '_gold_upgrades', goldUpgradeCollection));

    }

    /**
     * @override
     */
    initializeView() {

        // <div id="pointUpgradesPanel" class="primary-upgrade-panel-body" style="display: none;">

        const parent = Page.getElement(this.parentId);
        const mainElement = Page.createElement('div', parent, this.elementId, 'primary-upgrade-panel-body');

        mainElement.style.display = 'none';
        
        this.setInitialVisibility(false);

        super.initializeView();
    }
}